import React from 'react';
import { format } from 'date-fns';
import _ from 'lodash';

const days = schedule => {
  const days = [];
  schedule.availabilities.forEach(a => {
    if (days.filter(d => d.day === format(a.time.start, 'dd')).length < 1) {
      days.push({
        day: format(a.time.start, 'dd'),
        time: a.time.start
      });
    } else if (days.filter(d => d.day === format(a.time.end, 'dd')).length < 1) {
      days.push({
        day: format(a.time.end, 'dd'),
        time: a.time.end
      });
    }
  });
  return _.sortBy(days, 'time').map(day => {
    return {
      key: day.time,
      render: /*#__PURE__*/React.createElement(React.Fragment, null)
    };
  });
};

export default days;